import React, { useEffect, useState } from "react";

const HERO_IMAGES = [
  "https://res.cloudinary.com/dicvjx88i/image/upload/v1775398796/bmb_banner_1_iepggg.jpg",
  "https://res.cloudinary.com/dicvjx88i/image/upload/v1775398796/bmb_banner_2_oswk8i.jpg",
  "https://res.cloudinary.com/dicvjx88i/image/upload/v1775398796/bmb_banner_3_k5pdwu.jpg",
];

const SLIDE_INTERVAL_MS = 6500;

const Hero = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const sync = () => setReduceMotion(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  useEffect(() => {
    if (reduceMotion || HERO_IMAGES.length < 2) return undefined;
    const id = window.setInterval(() => {
      setActiveIndex((i) => (i + 1) % HERO_IMAGES.length);
    }, SLIDE_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [reduceMotion]);

  return (
    <div className={`hero${reduceMotion ? " hero--reduced-motion" : ""}`}>
      <div className="hero-slides" aria-hidden="true">
        {HERO_IMAGES.map((url, i) => (
          <div
            key={url}
            className={`hero-slide${i === activeIndex ? " hero-slide--visible" : ""}`}
            style={{ backgroundImage: `url("${url}")` }}
          />
        ))}
      </div>
      <div className="hero-gradient" aria-hidden="true" />
      <div className="hero-text">
        Elevate your space, elevate your life - expert tile installations for a timeless look
      </div>
    </div>
  );
};

export default Hero;
